export default "__VITE_ASSET__j$r__ykC__"